exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.generated-outfit-info-container.hide-initial-buttons[data-v-53793338] {\n  top: 100%;\n}\n@media (max-height: 610px) {\n.generated-outfit-info-container.hide-initial-buttons[data-v-53793338] {\n    top: 100%;\n}\n}", ""]);

// exports
